import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../../../api";

const ChecklistReminder = () => {
  const [paramedicId, setParamedicId] = useState("");
  const [checklistType, setChecklistType] = useState("");
  const [paramedics, setParamedics] = useState([]);
  const [assignedParamedics, setAssignedParamedics] = useState([]);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingParamedics, setLoadingParamedics] = useState(false);
  const [assignChecklist, setAssignChecklist] = useState("medical_center","location");


  // Fetch paramedics based on assignChecklist type and assigned paramedics
  useEffect(() => {
    const fetchParamedics = async () => {
      setLoadingParamedics(true);
      try {
        const endpoint = assignChecklist === "location" 
          ? "/ems/get-paramedic-by-type/location" 
          : "/ems/get-paramedic-by-type/medical_center";
        const response = await axiosInstance.get(endpoint, {
          headers: {
            Authorization: "Bearer 1349|VFSxfHmNSspz9ZhH1Nu9L5yxoD9vlzPoI9BKifiE324f1ef0",
          },
        });

        if (response.data.status === "success") {
          const formattedParamedics = response.data.data.map(paramedic => ({
            id: paramedic.id,
            name: `${paramedic.first_name} ${paramedic.last_name}`,
          }));
          setParamedics(formattedParamedics);
        } else {
          alert("Failed to fetch paramedics.");
        }
      } catch (error) {
        console.error("Error fetching paramedics:", error.response?.data || error.message);
        alert("Error fetching paramedics: " + (error.response?.data?.message || error.message));
      } finally {
        setLoadingParamedics(false);
      }
    };

    const fetchAssignedParamedics = async () => {
      try {
        const response = await axiosInstance.get("/ems/get-checklist-reminder", {
          headers: {
            Authorization: "Bearer 1349|VFSxfHmNSspz9ZhH1Nu9L5yxoD9vlzPoI9BKifiE324f1ef0",
          },
        });
        if (response.data.status === "success") {
          setAssignedParamedics(response.data.data);
        } else {
          alert("Failed to fetch assigned paramedics.");
        }
      } catch (error) {
        console.error("Error fetching assigned paramedics:", error.response?.data || error.message);
        alert("Error fetching assigned paramedics: " + (error.response?.data?.message || error.message));
      }
    };

    fetchParamedics();
    fetchAssignedParamedics();
  }, [assignChecklist]);

  // Auto-fill fields when paramedic is selected
  useEffect(() => {
  if (paramedicId) {
    const existingAssignment = assignedParamedics.find(
      assignment => assignment.paramedic_id === parseInt(paramedicId)
    );
    if (existingAssignment) {
      // Only update from DB if assignment exists
      setAssignChecklist(existingAssignment.assign_checklist);
      setChecklistType(existingAssignment.checklist_type);
    } else {
      // Reset checklistType only, keep current assignChecklist
      setChecklistType("");
    }
  } else {
    setChecklistType("");
  }
}, [paramedicId, assignedParamedics]);

  // Handle save checklist assignment
  const handleSave = async () => {
    if (!assignChecklist || !paramedicId || !checklistType) {
      alert("Please select assignment type, paramedic, and checklist type.");
      return;
    }
    setLoadingSave(true);
    try {
      const selectedParamedic = paramedics.find(p => p.id === parseInt(paramedicId));
      const payload = {
        assign_checklist: assignChecklist,
        paramedic_id: paramedicId,
        paramedic_name: selectedParamedic ? selectedParamedic.name : "",
        checklist_type: checklistType.toLowerCase(),
      };

      const response = await axiosInstance.post(
        "/ems/save-checklist-reminder",
        payload
      );

      if (response.data.status === "success") {
        alert("Reminder Checklist saved successfully!");
        
        // Update or add to assignedParamedics
        setAssignedParamedics(prev => {
          const existingIndex = prev.findIndex(
            assignment => assignment.paramedic_id === parseInt(paramedicId)
          );
          if (existingIndex !== -1) {
            // Update existing assignment
            const updatedAssignments = [...prev];
            updatedAssignments[existingIndex] = {
              ...response.data.data,
              paramedic_id: parseInt(paramedicId),
              paramedic_name: selectedParamedic.name,
              assign_checklist: assignChecklist,
              checklist_type: checklistType.toLowerCase(),
            };
            return updatedAssignments;
          } else {
            // Add new assignment
            return [
              ...prev,
              {
                ...response.data.data,
                paramedic_id: parseInt(paramedicId),
                paramedic_name: selectedParamedic.name,
                assign_checklist: assignChecklist,
                checklist_type: checklistType.toLowerCase(),
              }
            ];
          }
        });

        // Reset form
        setParamedicId("");
        setChecklistType("");
        setAssignChecklist("location");
      } else {
        alert("Failed to save checklist reminder.");
      }
    } catch (error) {
      console.error("Error saving checklist reminder:", error.response?.data || error.message);
      alert("Error while saving checklist reminder: " + (error.response?.data?.message || error.message));
    } finally {
      setLoadingSave(false);
    }
  };

  // Handle delete checklist assignment
  const handleDelete = async (paramedicId) => {
    setLoadingDelete(true);
    try {
      const response = await axiosInstance.get(
        `/ems/delete-single-checklist/${paramedicId}`
      );

      if (response.data.status === "success") {
        alert("Checklist assignment deleted successfully!");
        setAssignedParamedics(assignedParamedics.filter(p => p.paramedic_id !== paramedicId));
        
        // If the deleted paramedic is currently selected, reset the form
        if (parseInt(paramedicId) === parseInt(paramedicId)) {
          setParamedicId("");
          setChecklistType("");
          setAssignChecklist("location");
        }
      } else {
        alert("Failed to delete checklist assignment.");
      }
    } catch (error) {
      console.error("Error deleting checklist assignment:", error.response?.data || error.message);
      alert("Error while deleting checklist assignment: " + (error.response?.data?.message || error.message));
    } finally {
      setLoadingDelete(false);
    }
  };

  return (
    <div className="tab-pane" id="checklist-reminder" role="tabpanel">
      <div className="data-panel mt-4">
        <h6 className="px-2 mb-2">Assign checklist to Paramedic:</h6>
        <div className="mb-4">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="radio"
              name="assignBy"
              id="byMedicalCenter"
              value="medical_center"
              checked={assignChecklist === "medical_center"}
              onChange={(e) => setAssignChecklist(e.target.value)}
            />
            <label className="form-check-label" htmlFor="byMedicalCenter">By Medical Center</label>
          </div>
          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="radio"
              name="assignBy"
              id="byLocation"
              value="location"
              checked={assignChecklist === "location"}
              onChange={(e) => setAssignChecklist(e.target.value)}
            />
            <label className="form-check-label" htmlFor="byLocation">By Location</label>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Paramedic:</label>
              <select
                className="form-select"
                value={paramedicId}
                onChange={(e) => setParamedicId(e.target.value)}
                disabled={loadingParamedics}
              >
                <option value="">Select Paramedic</option>
                {paramedics.map((paramedic) => (
                  <option key={paramedic.id} value={paramedic.id}>
                    {paramedic.name}
                  </option>
                ))}
              </select>
              {loadingParamedics && (
                <span className="spinner-border spinner-border-sm ms-2" role="status"></span>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Checklist Type:</label>
              <select
                className="form-select"
                value={checklistType}
                onChange={(e) => setChecklistType(e.target.value)}
              >
                <option value="">Select Checklist Type</option>
                <option value="vehicle">Vehicle</option>
                <option value="equipment">Equipment</option>
                <option value="both">Both</option>
              </select>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
            disabled={loadingSave || loadingParamedics}
          >
            {loadingSave ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
            ) : null}
            {loadingSave ? "Saving..." : "Save"}
          </button>
        </div>
        <h6 className="px-2 mb-2">Currently Assigned Paramedics:</h6>
        <table className="table">
          <thead>
            <tr>
              <th>Paramedic Name</th>
              <th>Location/Medical Center</th>
              <th>Checklist</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {assignedParamedics.map((assignment) => (
              <tr key={assignment.paramedic_id}>
                <td>{assignment.paramedic_name}</td>
                <td>{assignment.assign_checklist === "location" ? "Location" : "Medical Center"}</td>
                <td>{assignment.checklist_type.charAt(0).toUpperCase() + assignment.checklist_type.slice(1)}</td>
                <td>
                  <button
                    type="button"
                    className="btn p-0 border-0 bg-transparent"
                    onClick={() => handleDelete(assignment.paramedic_id)}
                    disabled={loadingDelete}
                  >
                    <i className="ti ti-trash text-danger fs-5"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChecklistReminder;